import {BubbleData} from '../../../../components/Bubble/Bubble';
//const Audio1 = require('./assets/3.mp3');

export default [
    {
        text: 'Piet, der Vogel, hat sich im riesigen Museum versteckt.',
        variant: 'bubble1',
        //voiceFile: Audio1,
    },
    {
        text: 'Hilf Nele, Piet zu finden.',
        variant: 'bubble1',
        //voiceFile: Audio1,
    },
] as BubbleData[];
